import { toReadOnlyValue } from "../utils";

export function generateDefaultValues() {
  return {
    dni: "",
    tipoDocumento: "",
    nacionalidad: "",
    apellidoPaterno: "",
    apellidoMaterno: "",
    primerNombre: "",
    segundoNombre: "",
    sexo: "",
    fechaNacimiento: "",
    direccion: "",
    referencia: "",
    departamento: "",
    provincia: "",
    distrito: "",
    telefono: "",
    telefonoReferencia: "",
    nroHijos: "",
    correo: "",
    puesto: "",
    estadoCivil: "",
    reclutador: "",
    fuente: "",
    experiencia: "",
    autorizacion: "",
  };
}
export const tipoDocumentoMap = {
  DNI: 1,
  PTP: 2,
  CE: 3,
  PASAPORTE: 4,
};
export const nacionalidadMap = {
  PERU: 1,
  VENEZUELA: 2,
  BOLIVIA: 3,
  ECUADOR: 4,
  COLOMBIA: 5,
  ARGENTINA: 6,
  CHILE: 7,
  URUGUAY: 8,
  BRASIL: 9,
  PARAGUAY: 10,
  MEXICO: 11,
  CUBA: 12,
};
export const estadoCivilMap = {
  "SOLTERO(A)": 1,
  "CASADO(A)": 2,
  "DIVORCIADO(A)": 3,
  "VIUDO(A)": 4,
};
export const reclutadores = [
  "SANCHEZ SOTO CARLOS ALONSO",
  "GALVEZ MAQUERA DANITZA YAMILE",
  "CANO DUPLEX MARIAN DALLANA",
  "MORI  RAMIREZ MARIELLA",
  "ARRASCUE GIRON RENATO",
  "MIÑANO JUAREZ KARROLL LEONILA",
  "VICENTE LAMPAS MARIA EMILIA",
  "ALVAREZ GUEDES ERICK FERNANDO",
  "AVALOS CASERES JACKELINE ARACELY",
  "PACHECO TORRES FABRIZIO RENAN",
  "MEDINA PELAEZ KATHERINE ALESANDRA",
  
];
export function generateFormReadOnly(form, depa, prov, distri) {
  const departamentoReadOnly =
    depa.find((item) => item.value === form.departamento)?.label ??
    form.departamento;
  const provinciaReadOnly =
    prov.find((item) => item.value === form.provincia)?.label ?? form.provincia;
  const distritoReadOnly =
    distri.find((item) => item.value === form.distrito)?.label ?? form.distrito;
  return [
    {
      title: "Datos personales",
      fields: [
        { label: "DNI", value: toReadOnlyValue(form.dni) },
        {
          label: "Tipo de Documento",
          value: toReadOnlyValue(form.tipoDocumento),
        },
        {
          label: "Nacionalidad",
          value: toReadOnlyValue(form.nacionalidad),
        },
        {
          label: "Apellido Paterno",
          value: toReadOnlyValue(form.apellidoPaterno),
        },
        {
          label: "Apellido Materno",
          value: toReadOnlyValue(form.apellidoMaterno),
        },
        {
          label: "Primer Nombre",
          value: toReadOnlyValue(form.primerNombre),
        },
        {
          label: "Segundo Nombre",
          value: toReadOnlyValue(form.segundoNombre),
        },
        { label: "Sexo", value: toReadOnlyValue(form.sexo) },
        {
          label: "Fecha de Nacimiento",
          value: toReadOnlyValue(form.fechaNacimiento),
        },
      ],
    },
    {
      title: "Contacto y ubicación",
      fields: [
        { label: "Dirección", value: toReadOnlyValue(form.direccion) },
        {
          label: "Referencia Domiciliaria",
          value: toReadOnlyValue(form.referencia),
        },
        { label: "Departamento", value: toReadOnlyValue(departamentoReadOnly) },
        { label: "Provincia", value: toReadOnlyValue(provinciaReadOnly) },
        { label: "Distrito", value: toReadOnlyValue(distritoReadOnly) },
        {
          label: "Teléfono Celular",
          value: toReadOnlyValue(form.telefono),
        },
        {
          label: "Teléfono de Referencia",
          value: toReadOnlyValue(form.telefonoReferencia),
        },
        {
          label: "Correo Electrónico",
          value: toReadOnlyValue(form.correo),
        },
      ],
    },
    {
      title: "Perfil y evaluación",
      fields: [
        { label: "N° Hijos", value: toReadOnlyValue(form.nroHijos) },
        { label: "Puesto", value: toReadOnlyValue(form.puesto) },
        { label: "Estado Civil", value: toReadOnlyValue(form.estadoCivil) },
        { label: "Reclutador", value: toReadOnlyValue(form.reclutador) },
        { label: "Fuente", value: toReadOnlyValue(form.fuente) },
        { label: "Experiencia", value: toReadOnlyValue(form.experiencia) },
        {
          label: "Autorización de datos",
          value: toReadOnlyValue(form.autorizacion),
        },
      ],
    },
  ];
}
